import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { Select, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { QUERY_COUNTRY } from '../queries';

/**
 * @param {Object} params
 * @param {string[]} [params.excludedCountries] - The list of countries code to exclude from the country list
 */
const AsyncCountrySelector = ({
  value,
  onChange,
  onSelectCountryCurrency,
  onSelectItem,
  onBlur,
  placeholder,
  type,
  disabled,
  queryCountrySlugs,
  excludedCountries = [],
}) => {
  const { t } = useTranslation();
  const { data } = useQuery(QUERY_COUNTRY, {
    variables: {
      pageNumber: 1,
      pageSize: 100,
      countrySlugs: queryCountrySlugs,
    },
    onError: e => {
      message.error(e?.toString());
    },
  });
  const countryList = useMemo(() => {
    return (
      data?.countries?.edges.filter(edge => !excludedCountries.includes(edge.node.countryCode)) ||
      []
    );
  }, [data, excludedCountries]);

  return (
    <Select
      onBlur={onBlur}
      showSearch
      placeholder={placeholder || t('cms.referral.commission_plan.modal.country.placeholder')}
      value={value}
      filterOption={(input, option) =>
        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      onChange={v => {
        onChange(v);
        onSelectItem &&
          onSelectItem(
            countryList.find(i => (type === 'id' ? i.node.id === v : i.node.countryCode === v)),
          );
        onSelectCountryCurrency &&
          onSelectCountryCurrency(
            countryList.find(country =>
              type === 'id' ? country.node.id === v : country.node.countryCode === v,
            )?.node?.currencyCode,
          );
      }}
      disabled={disabled}
    >
      <For of={countryList} each="data" index="index">
        <Select.Option key={index} value={type === 'id' ? data.node.id : data.node.countryCode}>
          {data.node.name}
        </Select.Option>
      </For>
    </Select>
  );
};

export default AsyncCountrySelector;
